import React from 'react';
import PropTypes from 'prop-types';
import {Field} from 'formik';
import AsyncSelect from "react-select/async/dist/react-select.esm";

const CustomSelect = ({
                        field,
                        form,
                        meta,
                        label,
                        placeholder = 'בחירה...',
                        onChange,
                        disabled,
                        options,
                        isSearchable = true,
                        customStyles,
                        cacheOptions,
                        noOptionsMessage = () => 'אין אפשרויות',
                        loadingMessage = () => 'טוען נתונים...',
                        getOptionLabel,
                        getOptionValue,
                        loadOptions,
                        ...rest
                      }) => {
  const handleChange = (form, field) => option => {
    form.setFieldValue(field.name, option);
    if (onChange) {
      onChange(option);
    }
  };

  const commonProps = {
    cacheOptions,
    noOptionsMessage,
    loadingMessage,
    getOptionLabel,
    getOptionValue,
    loadOptions,
    styles: customStyles,
    value: field.value,
    onChange: handleChange(form, field),
    placeholder,
    isSearchable,
    isDisabled: disabled,
    ...rest,
  };
  const staticProps = {
    options
  };
  const props = {...commonProps, ...staticProps};

  return (
    <AsyncSelect {...props}/>
  );
};

const DataItemSelectAsync = ({
                               fieldId,
                               containerStyle = '',
                               sideLabelStyle = '',
                               inputContainerStyle = '',
                               sideLabel = null,
                               ...rest
                             }) => (
  <div className={containerStyle}>
    <div className={sideLabelStyle}>{sideLabel}</div>
    <div className={inputContainerStyle}>
      <Field
        id={fieldId}
        name={fieldId}
      >
        {fieldProps => <CustomSelect {...fieldProps} {...rest} />}
      </Field>
    </div>
  </div>
);

DataItemSelectAsync.propTypes = {
  fieldId: PropTypes.string,
  placeholder: PropTypes.node,
  onChange: PropTypes.func,
};

export default DataItemSelectAsync;
